import React, { useState, useEffect } from "react";
import MsgBoxModal from "../../../Components/MsgBoxModal/msgbox-modal.component";
import Toggle from "react-toggle";
import TextArea from "../../../Components/TextArea/text-area.component";
import MsgBoxSelect from "../../../Components/MsgBoxSelect/msg-box-select.component";

const AddResponseModal = ({ isOpen, submit, close }) => {
	const [reply, setReply] = useState("");
	const [requiresResponse, setRequiresResponse] = useState(false);
	const [featureType, setFeatureType] = useState({
		label: "None",
		value: false,
	});
	const [featureInfo, setFeatureInfo] = useState([]);
	const [flexBasis, setFlexBasis] = useState([]);
	const [captureAsEmailAddress, setCaptureAsEmailAddress] = useState(false);
	const [replyError, setReplyError] = useState("");

	useEffect(() => {
		let columns = 1;
		if (featureType.value === "Quick Reply") {
			columns = 2;
		} else if (featureType.value === "List") {
			columns = 3;
		}
		setFlexBasis(`${100 / columns}%`);
		setFeatureInfo([]);
	}, [featureType]);

	const handleAddReply = () => {
		// call parent to make request
		if (validate()) {
			submit(
				reply,
				requiresResponse,
				captureAsEmailAddress,
				featureType,
				featureInfo
			);
			destroyModal();
		}
	};

	const handleReplyChange = (event) => {
		setReply(event.target.value);
	};

	const handleRequiresResponseChange = (event) => {
		setRequiresResponse(event.target.checked);
	};

	const handleCaptureEmailResponseChange = (event) => {
		setCaptureAsEmailAddress(event.target.checked);
	};

	const destroyModal = () => {
		setReply("");
		setRequiresResponse(false);
		setCaptureAsEmailAddress(false);
		setReplyError("");
		close();
	};

	const validate = () => {
		if (!reply) {
			setReplyError("Reply is required");
			return false;
		} else {
			return true;
		}
	};

	return (
		<MsgBoxModal
			header="Add Reply"
			isOpen={isOpen}
			submit={handleAddReply}
			close={destroyModal}
			cancel={destroyModal}
			description="Use the form below to add a reply"
			submitButtonName="Add reply"
			aria={{
				labelledby: "heading",
				describedby: "full_description",
			}}
			customModalContentStyles={{ width: "60%" }}
			onRequestClose={destroyModal}
		>
			<div style={{ display: "flex", flexDirection: "row" }}>
				<div style={{ flexBasis: flexBasis }}>
					<TextArea
						onChange={handleReplyChange}
						value={reply}
						required
						label="Reply"
						error={replyError}
					/>
					<div>
						<MsgBoxSelect
							label="Feature"
							onChange={(option) => {
								console.log(option);
								setFeatureType(option);
							}}
							options={[
								{
									label: "None",
									value: false,
								},
								{
									label: "Quick Reply",
									value: "Quick Reply",
								},
								{
									label: "List",
									value: "List",
								},
							]}
							value={featureType}
							toolTipText="Add a message feature"
							hasTooltip
						/>
					</div>
					<div>
						<label
							style={{ display: "block" }}
							htmlFor="reply required"
						>
							Requires Reply?
						</label>
						<Toggle
							id="requires-reply"
							onChange={handleRequiresResponseChange}
							name="requires-reply"
							checked={requiresResponse}
						/>
					</div>
					<div>
						<label
							style={{ display: "block" }}
							htmlFor="edit-reply-required"
						>
							Capture Response as Email Address
						</label>
						<Toggle
							disabled={!requiresResponse}
							id="capture-as-email"
							onChange={handleCaptureEmailResponseChange}
							name="capture-email"
							checked={captureAsEmailAddress}
						/>
					</div>
				</div>
				{featureType.value === "Quick Reply" ? (
					<div style={{ flexBasis: flexBasis, marginLeft: 20 }}>
						<TextArea
							name="quickReply1"
							label="Button 1 Text"
							placeholder="Text For Button 1"
							value={featureInfo[0]}
							onChange={(event) => {
								if (event.target.value.length > 20) return;
								setFeatureInfo((prev) => {
									const newArr = [...prev];
									newArr[0] = event.target.value;
									return newArr;
								});
							}}
						/>
						<TextArea
							name="quickReply2"
							label="Button 2 Text"
							placeholder="Text For Button 2"
							value={featureInfo[1]}
							onChange={(event) => {
								if (event.target.value.length > 20) return;
								setFeatureInfo((prev) => {
									const newArr = [...prev];
									newArr[1] = event.target.value;
									return newArr;
								});
							}}
						/>
						<TextArea
							name="quickReply3"
							label="Button 3 Text"
							placeholder="Text For Button 3"
							value={featureInfo[2]}
							onChange={(event) => {
								if (event.target.value.length > 20) return;
								setFeatureInfo((prev) => {
									const newArr = [...prev];
									newArr[2] = event.target.value;
									return newArr;
								});
							}}
						/>
					</div>
				) : featureType.value === "List" ? (
					<>
						<div style={{ flexBasis: flexBasis, marginLeft: 20 }}>
							<TextArea
								name="list1"
								label="List Item 1"
								placeholder="Text For Item 1"
								value={featureInfo[0]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[0] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list2"
								label="List Item 2"
								placeholder="Text For Item 2"
								value={featureInfo[1]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[1] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list3"
								label="List Item 3"
								placeholder="Text For Item 3"
								value={featureInfo[2]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[2] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list4"
								label="List Item 4"
								placeholder="Text For Item 4"
								value={featureInfo[3]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[3] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list5"
								label="List Item 5"
								placeholder="Text For Item 5"
								value={featureInfo[4]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[4] = event.target.value;
										return newArr;
									});
								}}
							/>
						</div>
						<div style={{ flexBasis: flexBasis, marginLeft: 20 }}>
							<TextArea
								name="list6"
								label="List Item 6"
								placeholder="Text For Item 6"
								value={featureInfo[5]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[5] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list7"
								label="List Item 7"
								placeholder="Text For Item 7"
								value={featureInfo[6]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[6] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list8"
								label="List Item 8"
								placeholder="Text For Item 8"
								value={featureInfo[7]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[7] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list9"
								label="List Item 9"
								placeholder="Text For Item 9"
								value={featureInfo[8]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[8] = event.target.value;
										return newArr;
									});
								}}
							/>
							<TextArea
								name="list10"
								label="List Item 10"
								placeholder="Text For Item 10"
								value={featureInfo[9]}
								onChange={(event) => {
									if (event.target.value.length > 24) return;
									setFeatureInfo((prev) => {
										const newArr = [...prev];
										newArr[9] = event.target.value;
										return newArr;
									});
								}}
							/>
						</div>
					</>
				) : null}
			</div>
		</MsgBoxModal>
	);
};

export default AddResponseModal;
